import { teacherListRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { createRoute } from "@/routes/utils";
import { IRoleEnum } from "@/interfaces";

const permission = [IRoleEnum.Student];

const teacherListRouteMetadata: IRouteMetadataObj<typeof teacherListRoutesObj> =
  {
    list: {
      title: "teacherList.index.title",
      description: "teacherList.index.description",
      lazy: () => import("@/pages/studentPages/teacherList/table/page"),
      mode: "index",
      type: "main",
      icon: "BookLine",
      breadcrumbs: [],
      permission,
      noUser: true,
    },
    view: {
      title: "teacherList.view.title",
      description: "teacherList.view.description",
      lazy: () => import("@/pages/studentPages/teacherList/view/page"),
      mode: "edit",
      type: "inner",
      icon: "EyeLine",
      breadcrumbs: [],
      permission,
      noUser: true,
    },
  };

export const teacherListRoutes = createRoute<typeof teacherListRoutesObj>(
  teacherListRoutesObj,
  teacherListRouteMetadata,
);
